import React, { Component } from 'react';
import {connect} from 'react-redux';

//Actions
import {
  apiGetVehicle,
  apiGetVehiclesRelated, apiPostFinancingSimulator, clearDataVehicle, clearFinancingSimulator, setVehiclesState,
} from '../../../../common/modules/vehicles/VehiclesActions';

//Components
import ModalReservation from './ModalReservation';
import RangeInput from '../../components/RangeInput';

// Resource
import {
  toggleModal,
  closeModalBackdrop,
  removeTooltips,
  startCarousel,
  startTooltips, startSelectPicker, getDimensionElement, startVehicleRelated,
} from '../../resources/styles/js/custom';
import {getAsset} from '../../../../common/resources/assets/assets';
import {strings} from '../../../../common/resources/locales/i18n';
import VehiclesManager from '../../../../common/modules/vehicles/VehiclesManager';
import {AsyncImage} from '../../components/AsyncImage';
import {Loading} from '../../components';
import Routing from '../routing/Routing';
import {Link} from 'react-router-dom';
import {addComparator} from '../../../../common/modules/comparator/ComparatorActions';
import {Modal} from '../../components/Modal';
import { ImageSvg } from '../../components/ImageSvg';
import {getSimulationResult, legalScripts_Default} from '../../../../common/utils/Utils';
import ModelsItem from "../models/components/ModelItem";
import ModelsManager from "../../../../common/modules/models/ModelsManager";


class VehiclesDetailsContainer extends Component {

  state = {
    stateZoom: false,
  }

  async componentDidMount() {
    this._loadUpdateView()
  }

  async componentDidUpdate(prevProps,) {
    if (prevProps.idParams !== this.props.idParams) {
      this._loadUpdateView()
    }
  }

  componentWillUnmount() {
    document.title = this.previousTitle;
  }

  render() {
    const {
      dataVehicleDetail, isLoadingVehicle, initialEntry, postponement,
      vehicleLandingGalleryBottom, financeSimulationAmountStep,
      financeAllowedMonths, isLoadingFinancing, financeSimulationMinAmount,
    } = this.props;

    if (isLoadingVehicle){
      return (
        <main id="main" role="main">
          <section id="product-info" className="pt-5">
            <div className='w-100 my-5 py-5'>
              <Loading/>
            </div>
          </section>
        </main>
      )
    }

    if (dataVehicleDetail === null){
      return (
        <>
        <main id="main" role="main">
          <section id="product-info" className="pt-5">
            <div className='w-100 my-5 py-5'>
              <div className="text-center">
                {strings('vehicleDetails.emptyListFilter')}
              </div>
            </div>
          </section>
        </main>
        </>
      )
    }

    const name = VehiclesManager.getName(dataVehicleDetail);
    const priceFormat = VehiclesManager.getPriceFormat(dataVehicleDetail);
    const finalPriceFormat = VehiclesManager.getFinalPriceFormat(dataVehicleDetail);
    const cuotaPriceFormat = VehiclesManager.getCuotaPriceFormat(dataVehicleDetail);
    const gearboxDescription = VehiclesManager.getGearboxDescription(dataVehicleDetail);
    const images = VehiclesManager.getImagesList(dataVehicleDetail);
    const environIconUrl = VehiclesManager.getEnvironIconUrl(dataVehicleDetail);
    const tyresPdfUrl = VehiclesManager.getTyresPdfUrl(dataVehicleDetail);
    const co2 = VehiclesManager.getCo2(dataVehicleDetail);
    const consumptionFormatted = VehiclesManager.getConsumptionFormatted(dataVehicleDetail);
    const power = VehiclesManager.getPower(dataVehicleDetail);
    const modelGroupDescription = VehiclesManager.getModelGroupDescription(dataVehicleDetail);
    const fuelDescription = VehiclesManager.getFuelDescription(dataVehicleDetail);
    const colorDescription = VehiclesManager.getColorDescription(dataVehicleDetail);
    const modelUrlKey = VehiclesManager.getModelUrlKey(dataVehicleDetail);
    const featuredEquipmentList = VehiclesManager.getFeaturedEquipmentList(dataVehicleDetail);
    const vin = VehiclesManager.getVin(dataVehicleDetail);

    const localizationName = VehiclesManager.getLocalizationName(dataVehicleDetail);
    const localizationAddress = VehiclesManager.getLocalizationAddress(dataVehicleDetail);
    const deliveryLabel = VehiclesManager.getDeliveryLabel(dataVehicleDetail);

    /* FINANCING */
    const arrayMonth = financeAllowedMonths.split(',');
    const minMonth = parseFloat(arrayMonth[0]);
    const maxMonth = parseFloat(arrayMonth[arrayMonth.length - 1]);
    const stepMonth = parseFloat(arrayMonth[1]) - parseFloat(arrayMonth[0]);
    const maxInitialEntry = VehiclesManager.getFinalPrice(dataVehicleDetail);

    /* OPTIONAL EQUIPMENT LIST */
    const optionalEquipmentList = VehiclesManager.getOptionalEquipmentList(dataVehicleDetail);


    const tags =  VehiclesManager.getTags(dataVehicleDetail);

    return (
      <>
        <main id="main" role="main">
          <section id="product-info" className="pt-4">
            <div className="container">

            <p className="d-none d-lg-block mb-lg-4 h6 small-lg">
              <Link replace to={`${Routing.vehicle}${modelUrlKey}`} className="text-muted">
                <ion-icon name="arrow-back-outline"/> {strings('models.backToTheList') + ' '}
                <span>{modelGroupDescription}</span>
              </Link>
            </p>

              <div className="row d-flex">
                <div className="col-lg-7">
                  <div className="gallery-wrapper pt-3 pt-lg-5 position-relative">
                    {/* Galería */}
                    <div className="product-availability position-absolute top-0 left-0">
                      {tags && tags.map((item, key)=>{
                        const backgroundHexColor = ModelsManager.getBackgroundHexColor(item)
                        const tagText = ModelsManager.getTagText(item)
                        const textHexColor = ModelsManager.getTextHexColor(item)

                        return(
                          <div key={key} className="badge badge-success mr-2 card-tag" style={{backgroundColor: backgroundHexColor, color: textHexColor, textTransform: 'uppercase' }}>
                            {tagText || ''}
                          </div>
                        )
                      })}
                    </div>

                    <div className="product-actions position-absolute top-0 right-0 d-lg-flex align-items-center">
                      <Link
                        replace to={Routing.nowhere}
                        className={`mr-2 p-2`}
                        data-toggle="tooltip"
                        data-placement="top"
                        title={strings('tooltip.addComparer')}
                        onClick={() => this._addComparator(dataVehicleDetail)}
                      >
                        <ImageSvg src={getAsset('icComparator')}/>
                      </Link>
                    </div>


                    <div id="product-info-slider" className="owl-carousel owl-theme">
                      {this._renderImages(images, modelGroupDescription)}
                    </div>

                   {/* <div className="product-actions position-absolute top-0 right-0 d-lg-flex align-items-center">
                      <a href="comparador.php" className="m-0 p-1 bg-light" data-toggle="tooltip" data-placement="top"
                         title="" data-original-title="Añadir al comparador">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"
                             className="svg replaced-svg">
                          <path
                            d="M19.125 6.375H29.9199L30.2393 6.96484L33.4893 12.9668C33.8956 13.7173 34.125 14.5836 34.125 15.5C34.125 18.2609 32.0096 20.625 29.25 20.625C26.4904 20.625 24.375 18.2609 24.375 15.5C24.375 14.5836 24.6044 13.7173 25.0107 12.9668L27.3613 8.625H19.125V30.75H24V33H12V30.75H16.875V8.625H8.63867L10.9893 12.9668C11.3956 13.7173 11.625 14.5836 11.625 15.5C11.625 18.2609 9.50964 20.625 6.75 20.625C3.99036 20.625 1.875 18.2609 1.875 15.5C1.875 14.5836 2.1044 13.7173 2.51074 12.9668L5.76074 6.96484L6.08008 6.375H16.875V3H19.125V6.375ZM4.48926 14.0381C4.25923 14.463 4.125 14.9614 4.125 15.5C4.125 17.1573 5.36758 18.375 6.75 18.375C8.13242 18.375 9.375 17.1573 9.375 15.5C9.375 14.9614 9.24077 14.463 9.01074 14.0381L6.75 9.8623L4.48926 14.0381ZM26.9893 14.0381C26.7592 14.463 26.625 14.9614 26.625 15.5C26.625 17.1573 27.8676 18.375 29.25 18.375C30.6324 18.375 31.875 17.1573 31.875 15.5C31.875 14.9614 31.7408 14.463 31.5107 14.0381L29.25 9.8623L26.9893 14.0381Z"
                            fill="currentColor"></path>
                        </svg>
                      </a>
                    </div>*/}

                  </div>
                  <p
                    className='text-muted small'
                    ref={el => el && el.style.setProperty('margin', '40px 0', 'important')}>
                    {vehicleLandingGalleryBottom}
                  </p>
                </div>

                <div className="col-lg-4 offset-lg-1">
                  <div className="product-info">
                    <div className="card">
                      <div className="card-body product-name p-lg-0 pt-lg-3">
                        <div
                          className="text-primary h3 mb-2 lh-condensed px-lg-3 pt-lg-2">
                          {name}
                        </div>
                        <p className="small-lg text-muted mb-3">{strings('vehicleDetails.numberVin')}: {vin}</p>
                        <div id="specs-module">
                        <div className="specs-grid">
                          {fuelDescription ? <div className="spec-item">
                            <div className="spec-icon">
                              <ImageSvg src={getAsset('icFlash')}/>
                            </div>
                            <div className="spec-text">{fuelDescription}</div>
                          </div> : <></>}
                          {power ? <div className="spec-item">
                            <div className="spec-icon">
                              <ImageSvg src={getAsset('icEngine')}/>
                            </div>
                            <div className="spec-text">{strings('vehicleDetails.powerValue', {value: power})}</div>
                          </div> : <></>}
                          {gearboxDescription? <div className="spec-item">
                            <div className="spec-icon">
                              <ImageSvg src={getAsset('icGearbox')}/>
                            </div>
                            <div className="spec-text">{gearboxDescription}</div>
                          </div> : <></>}
                          {consumptionFormatted ? <div className="spec-item">
                            <div className="spec-icon">
                              <ImageSvg src={getAsset('icFuelMeter')}/>
                            </div>
                            <div className="spec-text">{consumptionFormatted}</div>
                          </div> : <></>}
                          {colorDescription? <div className="spec-item">
                            <div className="spec-icon">
                              <ImageSvg src={getAsset('icColorFilter')}/>
                            </div>
                            <div className="spec-text">{colorDescription}</div>
                          </div> : <></>}
                        </div>
                      </div>
                      </div>
                      <div className="card-footer product-price p-3">
                        <div className="h6 text-dark text-uppercase small-lg">{strings('vehicleDetails.monthlyFee')}</div>
                        <div className="h4 text-secondary mb-2">{cuotaPriceFormat} <small>{strings('models.from2')}</small></div>

                        <div className="d-none d-lg-block">
                          <a href="#calculadora" className="text-primary h6 smooth">
                            <ion-icon name="calculator-outline"></ion-icon>
                            {strings('models.customizeQuotas')}
                          </a>
                        </div>
                        <div className="d-lg-none">
                          <a href="#calculadora" data-toggle="collapse" className="text-primary h6 mb-0"
                             role="button" aria-expanded="false" aria-controls="calculadora-mobile">
                            <ion-icon name="calculator-outline"></ion-icon>
                            {strings('models.customizeQuotas')}
                          </a>
                          tres
                        </div>
                      </div>
                      <div className="card-footer product-price p-3">
                        <div className="h6 text-dark text-uppercase small-lg">{strings('models.spotPrice')}</div>
                        <div className="h4 text-dark m-0">
                          {finalPriceFormat !== priceFormat ? <s className="small-md text-muted mr-1">{priceFormat}</s> : <></>}
                          {' ' +finalPriceFormat}
                        </div>


                      </div>
                      <div className="card-footer product-dag p-3">
                        {localizationName? <div className="h6 text-dark text-bold mb-1">{localizationName}</div>: localizationName}
                        {deliveryLabel ? <div className="text-uppercase fw-bold small-lg text-secondary mb-0">{deliveryLabel}</div> : <></>}
                        {localizationAddress? <p className="text-dark lh-condensed small-lg mt-0">{localizationAddress}</p> :<></>}
                      </div>
                    </div>
                    <div className="col-buy mt-3">
                      <Link to={Routing.nowhere} className="btn btn-lg btn-block btn-secondary" data-toggle="modal" data-target="#modalReservation">{strings('button.imInterested')}</Link>
                      <Link to={Routing.nowhere} onClick={() => this._addComparator(dataVehicleDetail)} className="btn btn-lg btn-block btn-outline-primary d-lg-none">{strings('tooltip.addComparer')}</Link>
                    </div>
                  </div>
                </div>

                {/*<div className="col-lg-4 offset-lg-1">
          <div className="product-info">
             <!-- Info + Price + CTA -->
            <div className="card">
              <div className="card-body product-name">
                <h1 className="text-primary h3 mb-1">{name}</h1>
                <div className={''}>
                <p className="text-dark mb-2">{modelGroupDescription} | {strings('vehicleDetails.numberVin')} {vin}</p>
                </div>
                <ul className="list-inline small-lg">
                  {fuelDescription ?
                    <li className="list-inline-item mr-md-3">
                      <ion-icon name="flash-outline"/>{' ' + fuelDescription}
                    </li> :
                    <></>
                  }
                  {gearboxDescription ?
                    <li className="list-inline-item mr-md-3">
                      <ion-icon name="cog-outline"/> {' ' + gearboxDescription}
                    </li> :
                    <></>
                  }
                  {colorDescription ?
                    <li className="list-inline-item">
                      <ion-icon name="color-filter-outline"/>{' ' + colorDescription}
                    </li> :
                    <></>
                  }
                </ul>
              </div>


              {localizationName || deliveryLabel || localizationAddress ? <div className="card-footer ">
                <div className='d-flex'>
                  <ion-icon name="location-outline"></ion-icon>
                  <div className={'ml-1 mt-1'}>
                    <ul className="list-inline small-lg">
                      {localizationName ? <div className="h6 text-dark text-uppercase small-lg mb-1">{localizationName}</div> : <></>}
                      {deliveryLabel ? <div className="h6 text-uppercase small-lg text-secondary mb-0">{deliveryLabel}</div>: <></>}
                      {localizationAddress ? <p className="text-dark small-lg mt-0">{localizationAddress}</p> : <></>}
                    </ul>
                  </div>
                </div>
              </div> :<></>}


              <div className="card-footer product-price">
                <div className="h6 text-dark text-uppercase small-lg mt-2">{strings('models.monthlyFee')}</div>
                <div className="h4 text-secondary mb-0">
                  {cuotaPriceFormat} <small>{strings('models.from2')}</small>
                </div>
                <ul className="list-inline small-lg mb-2">
                  <li className="list-inline-item mr-md-3">{financeExampleLanding}</li>
                </ul>
                <a href="#calculadora" className="text-primary h6">
                  <ion-icon name="calculator-outline"/>{' ' + strings('models.customizeQuotas')}
                </a>
              </div>
              <div className="card-footer product-price">
                <div className="h6 text-dark text-uppercase small-lg mt-2">{strings('models.spotPrice')}</div>
                <div className="h4 text-dark mb-2">
                  {finalPriceFormat !== priceFormat ? <s className="small-md text-muted mr-1">{priceFormat}</s> : <></>}
                  {' ' +finalPriceFormat}
                  </div>
              </div>
            </div>
            <div className="col-buy mt-0">
              <a className="btn btn-lg btn-block btn-primary" href="#" data-toggle="modal" data-target="#modalReservation">
                {strings('button.imInterested')}
              </a>
              <div className="product-actions-bottom d-flex d-lg-none align-items-center justify-content-center">
              <Link
                    replace to={Routing.nowhere}
                    onClick={() => this._addComparator(dataVehicleDetail)}
                    className="mr-2 p-2"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={strings('tooltip.addComparer')}
                  >
                    <ion-icon name="duplicate-outline"/>
                  </Link>
    	        </div>
            </div>
          </div>
        </div>*/}
              </div>

            </div>
          </section>

          {(optionalEquipmentList && optionalEquipmentList.length > 0) || (featuredEquipmentList && featuredEquipmentList.length > 0) || tyresPdfUrl ?
          <section id="product-equipment-2" className="pt-4">
            <div className="container">
              <div className="heading-section">
                <h2>{strings('vehicleDetails.optionalEquipment')}</h2>
              </div>
              <div className="row row-cols-1 row-cols-md-2 justify-content-center">
                {optionalEquipmentList && optionalEquipmentList.length > 0 &&
                  <div className="col mb-4">
                    <div className="card h-100">
                      <div className="card-header h5 p-4">{strings('vehicleDetails.optional')}</div>
                      <div className="card-body p-4">
                        <ul className="list-unstyled mb-0">
                          {optionalEquipmentList.map((item, index) => (
                            <li key={index} className="py-1">
                              <ion-icon name="checkmark-outline" className="text-accent mr-1 md hydrated" role="img"></ion-icon>
                              <span dangerouslySetInnerHTML={{__html: item}}></span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                }
                {((featuredEquipmentList && featuredEquipmentList.length > 0) || tyresPdfUrl) &&
                  <div className="col mb-4">
                    <div className="card h-100">
                      <div className="card-header h5 p-4">{strings('vehicleDetails.standard')}</div>
                      <div className="card-body p-4">
                        <div className="accordion" id="accordionEquipment2">
                          {featuredEquipmentList && featuredEquipmentList.map((item, index) => (
                            <div className="accordion-item" key={index}>
                              <div className="accordion-header" id={`heading2-${index}`}>
                                <h5 className="mb-0">
                                  <a className="collapsed" role="button" data-toggle="collapse" data-target={`#collapse2-${index}`} aria-expanded="false" aria-controls={`collapse2-${index}`}>
                                    {item.title}
                                    <ion-icon name="chevron-down-outline" role="img" className="md hydrated"></ion-icon>
                                  </a>
                                </h5>
                              </div>
                              <div id={`collapse2-${index}`} className="collapse" aria-labelledby={`heading2-${index}`} data-parent="#accordionEquipment2">
                                <div className="accordion-body px-0">
                                  <ul>
                                    {item.equipment && item.equipment.map((eq, eqIndex) => (
                                      <li key={eqIndex}>{eq}</li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          ))}
                          {tyresPdfUrl &&
                            <div className="accordion-item">
                              <div className="accordion-header" id="heading2-tyres">
                                <h5 className="mb-0">
                                  <a className="collapsed" role="button" data-toggle="collapse" data-target="#collapse2-tyres" aria-expanded="false" aria-controls="collapse2-tyres">
                                    {strings('vehicleDetails.tireLabels')}
                                    <ion-icon name="chevron-down-outline" role="img" className="md hydrated"></ion-icon>
                                  </a>
                                </h5>
                              </div>
                              <div id="collapse2-tyres" className="collapse" aria-labelledby="heading2-tyres" data-parent="#accordionEquipment2">
                                <div className="accordion-body">
                                  <p>
                                    <a href={tyresPdfUrl} target="_blank" rel="noreferrer">{strings('vehicleDetails.tireLabels')}<ion-icon name="open-outline" role="img" className="md hydrated"></ion-icon></a>
                                  </p>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </section> : <></>
          }

          <section id="calculadora">
            <div className="container">
              <div className="heading-section">
                <h2>{strings('models.customizeFinancing')}</h2>
              </div>

              <div className="row row-cols-1 row-cols-md-2">
                <div className="col mb-4">
                  <div className="card h-100">
                    <div className="card-header h5 p-4">
                      {strings('models.choosePrefences')}
                    </div>
                    <div className="card-body p-4 d-flex align-items-center">
                      <form className='w-100' onSubmit={(e) => this._submitFinancing(e)}>
                        <div className="form-group mb-4">
                          <RangeInput
                            id={'initialEntry'}
                            inputClean={{
                              value: true, minValue: 0,
                              maxValue: maxInitialEntry - financeSimulationMinAmount, step: financeSimulationAmountStep,
                              classNameLabel: 'd-flex mb-0', classNameInput: 'custom-range',
                              containLabel: <>{strings('vehicleDetails.initialEntry')} (€) <span
                                className="ml-auto text-muted">{(initialEntry || initialEntry === 0) && initialEntry.toString() ? initialEntry.toString() : ''}{' '}€</span></>
                            }}
                            onChange={(e) => this._handleValueChange(e.target.id, parseFloat(e.target.value))}
                    value={initialEntry}
                  />
                </div>
                <div className="form-group mb-3">
                  <RangeInput
                      id={'postponement'}
                      inputClean={{
                        value: true, minValue: minMonth,
                        maxValue: maxMonth, step: stepMonth,
                        classNameLabel: 'd-flex mb-0', classNameInput: 'custom-range',
                        containLabel: <>{strings('vehicleDetails.postponement', {maxValue: maxMonth})} <span className="ml-auto text-muted">{strings('vehicleDetails.xMonths', {months: postponement})}</span></>
                      }}
                      onChange={(e) => this._handleValueChange(e.target.id, parseFloat(e.target.value))}
                      value={postponement}
                    />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col mb-4">
          <div className="card h-100">
            <div className="card-header h5 p-4">
              {strings('vehicleDetails.financingDetails')}
            </div>
            <div className="card-body p-4">
              <dl className="row mb-0">
                {isLoadingFinancing ?
                  <div
                    className='d-flex align-items-center justify-content-center w-100'
                    style={{minHeight: '264px'}}
                  >
                    <Loading />
                  </div>
                  : this.renderResultFinancing()
                }
              </dl>
            </div>
          </div>
        </div>
      </div>

    </div>
          </section>

          <section id="product-specs" className="pt-4">
            <div className="container">
              <div className="card">
                <div className="card-body p-4">
                  <div className="row row-cols-2 row-cols-md-5 justify-content-center">
                    {power ? <div className="col py-2 text-center">
                      <div className="font-weight-bold">{strings('vehicleDetails.power')}</div>
                      <div className="text-muted">{strings('vehicleDetails.powerValue', {value: power})}</div>
                    </div> : <></>}
                    {consumptionFormatted?<div className="col py-1 text-center">
                      <div className="font-weight-bold">{strings('vehicleDetails.consumption')}</div>
                      <div className="text-muted">{consumptionFormatted}</div>
                    </div> :<></>}
                    <div className="col py-2 text-center">
                      <div className="font-weight-bold">{strings('vehicleDetails.emissions')}</div>
                      <div className="text-muted">{strings('vehicleDetails.co2', {value: co2})}</div>
                    </div>
                    {gearboxDescription?<div className="col py-2 text-center">
                      <div className="font-weight-bold">{strings('vehicleDetails.shift')}</div>
                      <div className="text-muted">{gearboxDescription}</div>
                    </div>:<></>}
                    {co2 === '0' ?<div className="col py-1 text-center">
                      <div className="font-weight-bold">{strings('vehicleDetails.environmentalBadge')}</div>
                      <div className="text-muted"><img src={environIconUrl} className="img-fluid w-25"/></div>
                    </div>:<></>}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {this.renderVehiclesRelated()}

  <div className="container d-flex justify-content-center align-items-center" style={{paddingBottom: '5rem'}}>
    <a className="col-12 col-lg-4 btn btn-lg btn-block btn-secondary" href="#" data-toggle="modal" data-target="#modalReservation">
      {strings('button.imInterested')}
    </a>
  </div>

        </main>
        <button className="d-none" data-toggle="modal" data-target="#modalAddComparator" id='idAddComparator'/>
        {this._renderVehicleModalComparator()}
        <ModalReservation vehicle={dataVehicleDetail} history={this.props.history} />
      </>
    );
  }

  renderFeaturedEquipmentList () {
    const {dataVehicleDetail} = this.props;
    const featuredEquipmentList = VehiclesManager.getFeaturedEquipmentList(dataVehicleDetail);

    if (featuredEquipmentList && featuredEquipmentList.length !== 0){

      return featuredEquipmentList.map((item, index) => {
        return(
          <div className="accordion-item" key={index}>
            <div className="accordion-header" id="headingTwo">
              <div className="h5 mb-0">
                <a className="collapsed" role="button" data-toggle="collapse" data-target={"#" + item.title.replace(/\s/g, "")} aria-expanded={index === 0} aria-controls="accordionEquipment">
                  {item.title}
                  <ion-icon name="chevron-down-outline"/>
                </a>
              </div>
            </div>
            <div id={item.title.replace(/\s/g, "")} className={index === 0 ? "collapse show" : "collapse"} aria-labelledby="headingTwo"
                 data-parent="#accordionEquipment">
              <div className="accordion-body px-0">
                {
                  item.equipment.map((string ,indexString) => {
                    return <p key={indexString}>{string}</p>
                  })
                }
              </div>
            </div>
          </div>
        )
      })
    }
  }

  renderResultFinancing() {
    const { initialEntry, postponement, dataVehicleDetail,
      financeSimulationOpenFee,financeSimulationAmountStep, financeAllowedMonths, financeSimulationMinAmount, financeSimulationMonthRatioTable,financeSimulationTin,
    } = this.props;

    const finalPrice = VehiclesManager.getFinalPrice(dataVehicleDetail);

    const resultFinancing = getSimulationResult(
      { initialEntry, postponement, finalPrice},
      { openFee: financeSimulationOpenFee,financeSimulationAmountStep, financeAllowedMonths, financeSimulationMinAmount, financeSimulationMonthRatioTable,financeSimulationTin},
      )

    if (resultFinancing && resultFinancing.length > 0 && Array.isArray(resultFinancing)) {
      return resultFinancing.map((item,index) => {
        return (
          <div key={index} className='col-12 row mx-0 px-0'>
            <dd className={`col-7 ${item.value_code === 'tae' || item.value_code === 'quota' ? 'font-weight-bold' : ''}`}>{item.value_id}</dd>
            <dt className={`col-5 text-right ${item.value_code === 'tae' || item.value_code === 'quota' ? 'font-weight-bold' : 'font-weight-normal'}`}>{item.value_label}</dt>
          </div>
        )
      })
    }
  }

  renderOptionalEquipments(column) {
    const { dataVehicleDetail } = this.props;
    const optionalEquipment = VehiclesManager.getOptionalEquipmentList(dataVehicleDetail);
    const copyOptionalEquipment = optionalEquipment.slice();

    let middleArray = copyOptionalEquipment.length / 2;
    if (middleArray.toString().includes('.5')) {
      middleArray += 1;
    }
    middleArray = parseInt(middleArray);

    let column1 = copyOptionalEquipment.splice(0, middleArray);
    let column2 = copyOptionalEquipment;

    if (column === 'left') {
      return (
        <div className="col-md-6">
          <ul className="list-unstyled">
            {column1.map((item, index) => {
              return (
                <li key={index} className="py-1">
                  <ion-icon name="checkmark-outline" class="text-secondary mr-1"/>
                  <span dangerouslySetInnerHTML={{__html: item}}></span>
                </li>
              )
            })}
          </ul>
      </div>
      )
    } else if (column === 'right') {
      return (
        <div className="col-md-6">
          <ul className="list-unstyled">
            {column2.map((item, index) => {
              return (
                <li key={index} className="py-1">
                  <ion-icon name="checkmark-outline" class="text-secondary mr-1"/>
                  <span dangerouslySetInnerHTML={{__html: item}}></span>
                </li>
              )
            })}
          </ul>
      </div>
      )
    }

  }

  renderVehiclesRelated() {
    const { dataVehicleRelated, isLoadingRelated} = this.props;

    if (isLoadingRelated){
      return (<Loading/>)
    }

    if (dataVehicleRelated && dataVehicleRelated.length === 0){
      return (<></>)
    }

    return (
      <section id="product-crosselling" className="pt-4">
        <div className="container">
          <div className="heading-section mb-2">
            <h3 className="mb-0">{strings('vehicleDetails.youBeInterestedIn')}</h3>
          </div>
          <div id="product-related-slider" className="owl-carousel owl-theme">
            {dataVehicleRelated.map((item, idItem)=> {

              const description = VehiclesManager.getModelGroupDescription(item);
              const vin = VehiclesManager.getVin(item);
              const bestCuotaPriceFormat  = VehiclesManager.getCuotaPriceFormat(item);
              const bestFinalPrice = VehiclesManager.getFinalPriceFormat(item);
              const image = VehiclesManager.getImageMain(item);

              return(
                <div className="item" key={idItem}>
                  <ModelsItem
                    bestFinalPrice={bestFinalPrice}
                    description={description}
                    id={vin}
                    image={image}
                    bestCuotaPriceFormat={bestCuotaPriceFormat}
                    urlKey={vin}
                    routing={Routing.vehicleDetail}

                  />
                </div>
              )
            })}
          </div>
        </div>
      </section>
    )
  }

  /** PRIVATE METHOD **/
  async _loadUpdateView() {
    const { metasHomeTitle, metasHomeDescription, cookiesBannerScript, metricsGtmEnabled, metricsGtmId, financeAllowedMonths } = this.props;
    const splitFinanceMonths = financeAllowedMonths.split(',');

    if (legalScripts_Default) legalScripts_Default({
      metasHomeTitle, metasHomeDescription,
      cookiesBannerScript, metricsGtmEnabled, metricsGtmId
    });

    this._clearDataVehicle();
    await this._apiGetVehicle();
    await this._apiGetVehicleRelated();
    await this._clearFinancing();
    await this._handleValueChange(
      'postponement', parseFloat(splitFinanceMonths[splitFinanceMonths.length - 1])
    );
    await this._apiPostFinancingSimulator();
    startTooltips();
    startSelectPicker();
    startVehicleRelated();

    const {dataVehicleDetail} =this.props
    if (dataVehicleDetail && dataVehicleDetail.json_ld) {

      // Parseamos el HTML que llega
      const parser = new DOMParser();
      const doc = parser.parseFromString(dataVehicleDetail.json_ld, 'text/html');

      // Actualizamos el título si viene en el JSON
      const newTitle = doc.querySelector('title')?.innerText;
      if (newTitle) {
        document.title = newTitle;
      }
    }

  }

  async _addComparator(vehicle) {
    const {dataComparator, vehiclesCompareMax} = this.props;

    if (dataComparator && dataComparator.length === parseInt(vehiclesCompareMax)) {

      toggleModal('idAddComparator');
    } else {
      await this.props.addComparator(vehicle);
      removeTooltips();
    }
  }

  async _apiGetVehicle() {
    const {idParams} = this.props;
    await this.props.apiGetVehicle(idParams);
    startCarousel();
  }

  async _apiGetVehicleRelated() {
    const {idParams} = this.props;
    await this.props.apiGetVehiclesRelated(idParams);
  }

  _apiPostFinancingSimulator() {
    const { dataVehicleDetail } = this.props;
    this.props.apiPostFinancingSimulator(VehiclesManager.getFinalPrice(dataVehicleDetail));
  }

  async _clearDataVehicle() {
    await this.props.clearDataVehicle();
  }

  _onClickAccept() {
    const { history } = this.props;
    history.replace(Routing.comparator);
  }

  _renderCampaigns = (campaigns) => {
    if (campaigns && campaigns.length !== 0){

      return campaigns.map((item, index) => {
        return (
          <div className='d-flex align-items-center' key={index}>
            <span className='w-100 justify-content-start'> {item.label}</span>
            <span className='w-25'/>
            <p className='w-50 text-right align-content-end'>- {item.amount_formatted}</p>
          </div>
        )
      })
    }
  }


  _renderImages = (images, modelGroupDescription) => {
    if (images && images.length !== 0){
      const { stateZoom } = this.state;
      let dimensionsImg = {};
      if (getDimensionElement) dimensionsImg = getDimensionElement('product-info-slider');
      const widthScreen = window.innerWidth;

      return images.map((item, index) => {
        return (
          <div key={index} className='item' onClick={()=> this._setValueState('stateZoom', !stateZoom)}>
            <AsyncImage
              source={item}
              style={`bd-placeholder-img card-img-top ${widthScreen > 991 ? 'cursor-zoom-in' : ''}`}
              srcPlaceholder={getAsset('icPlaceholderModel')}
              minHeightLoading='184px'
              zoom={stateZoom && widthScreen > 991}
              zoomWidth={dimensionsImg && dimensionsImg.x ? dimensionsImg.x : 653}
              zoomHeight={dimensionsImg && dimensionsImg.y ? dimensionsImg.y : 367}
              alt={modelGroupDescription}
            />
          </div>
        )
      })
    }
  }

  _renderVehicleModalComparator() {
    const {vehiclesCompareMax} = this.props;
    return (
      <Modal
        body={strings('modals.comparatorFull.body', {value: vehiclesCompareMax})}
        classBody=''
        classBtnAccept='btn btn-primary'
        classBtnCancel='btn btn-secondary'
        idModal='modalAddComparator'
        onClickAccept={() => {
          if(closeModalBackdrop) {
            closeModalBackdrop();
          }
          this._onClickAccept();
        }}
        showBtnCancel={false}
        txtAccept={strings('modals.comparatorFull.txtAccept')}
        txtCancel={strings('modals.comparatorFull.txtCancel')}
        title={strings('modals.comparatorFull.title')}
      />
    )
  }

  _handleValueChange(prop, value) {
    this.props.setVehiclesState({prop, value});
  }

  _submitFinancing(e) {
    e.preventDefault();
    this._apiPostFinancingSimulator();
  }

  _clearFinancing() {
    this.props.clearFinancingSimulator();
  }

  _setValueState(prop, value){
    this.setState({[prop]: value});
  }
}

const mapStateToProps = ({ AppReducer, ComparatorReducer, VehiclesReducer }) => {
  const {
    financeExampleLanding, vehiclesCompareMax, metasHomeTitle,
    vehicleLandingBanner, metasHomeDescription, cookiesBannerScript,
    vehicleLandingGalleryBottom, metricsGtmEnabled, metricsGtmId,
    financeSimulationAmountStep, financeAllowedMonths, financeSimulationMinAmount,
    financeSimulationMonthRatioTable,financeSimulationTin, financeSimulationOpenFee
  } = AppReducer
  const { dataComparator } = ComparatorReducer
  const {
    dataVehicleDetail, isLoadingVehicle, initialEntry,
    postponement, takeOutInsurance, interestingOption,
    resultFinancing, isLoadingFinancing, dataVehicleRelated, isLoadingRelated
  } = VehiclesReducer

  return {
    financeExampleLanding, vehiclesCompareMax, metasHomeTitle,
    metasHomeDescription, cookiesBannerScript, vehicleLandingBanner,
    vehicleLandingGalleryBottom, metricsGtmEnabled, metricsGtmId,
    financeSimulationAmountStep, financeAllowedMonths, financeSimulationMinAmount,
    financeSimulationMonthRatioTable,financeSimulationTin, financeSimulationOpenFee,
    dataComparator,
    dataVehicleDetail, isLoadingVehicle, initialEntry,
    postponement, takeOutInsurance, interestingOption,
    resultFinancing, isLoadingFinancing, dataVehicleRelated, isLoadingRelated
  }
};

const mapStateToPropsAction = {
  apiPostFinancingSimulator,
  addComparator,
  apiGetVehicle,
  apiGetVehiclesRelated,
  clearDataVehicle,
  clearFinancingSimulator,
  setVehiclesState,
};

export default connect(mapStateToProps, mapStateToPropsAction)(VehiclesDetailsContainer);
